import React from "react";
import PriceFormatter from "../utils/PriceFormatter";
import { format } from "date-fns";
import { Box, MenuItem, TextField } from "@mui/material";
import { getGridDateOperators } from "@mui/x-data-grid";
import { IconButton, Menu } from '@mui/material';
import EditIcon from "@mui/icons-material/InfoOutlined"; 
import DebugLog from "../utils/DebugLog";
import { Settings } from "@mui/icons-material";


export const CurrencyCellRenderer = ({ value }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* <AttachMoneyIcon fontSize="small" /> */}
      {/* <span>RM</span>  */}
      {/* Malaysian Ringgit symbol */}
      <span style={{ marginLeft: "4px" }}>
        {" "}
        <PriceFormatter price={value} />
      </span>
    </div>
  );
};



export const onHoldPayoutCycleColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "transactionType",
    flex: 1.2,
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "transactionType" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "reportDate",
    headerName: "REPORT",
    flex: 0.5,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "reportDate" ? "bold-header-style" : null,
  },
  {
    field: "cutOffDate",
    headerName: "CUT OFF",
    headerClassName: (params) =>
      params.field === "cutOffDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "payOutDate",
    headerName: "PAYOUT BY",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "summaryAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerClassName: (params) =>
      params.field === "summaryAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
   
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
];
export const onHoldCompanyColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "batchNo",
    filterable: false,
    headerName: "BATCH NO.",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "version",
    filterable: false,
    headerName: "VERSION",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "transactionType",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "reportDate",
    flex: 0.5,
    headerName: "REPORT",
    headerAlign: "left",
  },
  {
    field: "cutOffDate",
    headerName: "CUT OFF",
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "payOutDate",
    headerName: "PAYOUT BY",
    flex: 0.5,
    headerAlign: "left",
  },
  // {
  //   field: "vendor",
  //   headerName: "VENDOR",
  //   flex: 1,
  //   headerAlign: "left",
  // },

  {
    field: "summaryAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
];


export const exclusionDealerListColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "exclusionTransactionTypes",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "companyCode",
    flex: 0.5,
    headerName: "CODE",
    headerAlign: "left",
  },
  {
    field: "startDate",
    headerName: "START",
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "endDate",
    headerName: "END",
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "reportDate",
    headerName: "REPORT DATE",
    flex: 1,
    headerAlign: "left",
  },

  {
    field: "incentiveAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];

export const exclusionTrasactionListColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "packageName",
    headerName: "YES ID",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "trxNo",
    flex: 0.5,
    headerName: "TRX NO.",
    headerAlign: "left",
  },
  {
    field: "exclusionTransactionTypes",
    headerName: "TYPE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "reportDate",
    headerName: "DATE",
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "commissionType",
    headerName: "NAME",
    flex: 1,
    headerAlign: "left",
  },

  {
    field: "incentiveAmount",
    headerName: "AMOUNT",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];

export const earmarksDetailsColumnHeader = [
  {
    field: "id",
    headerName: "ID",
    filterable: false,
    flex: 0.5,
    headerAlign: "left",
    hide: true, // hide column header
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.7,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "date",
    flex: 0.6,
    headerName: "DATE",
    headerAlign: "left",
    type: "date",
    valueGetter: ({ value }) => {
      // Ensure value is not null or undefined
      if (!value) return null;

      const dateParts = value.split("/").map((str) => parseInt(str, 10));
      // monthIndex starts at 0, ensure dateParts array has 3 elements
      if (dateParts.length === 3) {
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      } else {
        return null;
      }
    },
  },
  {
    field: "code",
    headerName: "CODE",
    flex: 0.6,
    headerAlign: "left",
  },

  // {
  //   field: "vendor",
  //   headerName: "VENDOR",
  //   flex: 1,
  //   headerAlign: "left",
  // },
  {
    field: "reason",
    headerName: "REASON",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "earmark",
    headerName: "EARMARK",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];

// incentives  column header
export const incentivesColumnHeader = [
  {
    field: "id",
    headerName: "ID",
    filterable: false,
    flex: 0.5,
    headerAlign: "center",
    hide: true, // hide column header
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
  },

  {
    field: "payoutId",
    headerName: "PAYOUT ID",
    filterable: false,
    flex: 0.5,
    headerAlign: "center",
    hide: true, // hide column header
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
  },
  {
    field: "description",
    headerName: "NAME",
    flex: 1,
    editable: true,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'left',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
  },

  {
    field: "reportDay",
    headerName: "REPORT",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    field: "cutOffDay",
    headerName: "CUT OFF",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },

  {
    field: "payoutDay",
    headerName: "PAYOUT BY",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },

  {
    field: "expiryStartDate",
    headerName: "BEGIN",
    type: "date",
    flex: 0.5,
    headerAlign: "center",
    editable: true,
    renderCell: (params) => {
      // Format the date for display
      return (
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
       <span>
          {params.value ? format(new Date(params.value), "MM/dd/yyyy") : ""}
        </span>
      </Box>
       
      );
    },
    renderEditCell: (params) => {
      // Custom edit component
      return (
        <TextField
          type="date"
          value={
            params.value ? format(new Date(params.value), "yyyy-MM-dd") : ""
          }
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
        />
      );
    },
  },
  {
    field: "expiryEndDate",
    headerName: "EXPIRY",
    type: "date",
    flex: 1,
    headerAlign: "center",
    editable: true,
    renderCell: (params) => {
      // Format the date for display
      return (
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
       <span>
          {params.value ? format(new Date(params.value), "MM/dd/yyyy") : ""}
        </span>
      </Box>
      );
    },
    renderEditCell: (params) => {
      // Custom edit component
      return (
        <TextField
          type="date"
          value={
            params.value ? format(new Date(params.value), "yyyy-MM-dd") : ""
          }
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
        />
      );
    },
  },
];

// device rembersiment column header
export const payoutdatesColumnHeader = [
  {
    field: "id",
    headerName: "ID",
    filterable: false,
    flex: 0.5,
    headerAlign: "center",
    hide: true, // hide column header
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
  },

  {
    field: "payoutId",
    headerName: "PAYOUT ID",
    filterable: false,
    flex: 0.5,
    headerAlign: "center",
    hide: true, // hide column header
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
  },
  {
    field: "description",
    headerName: "NAME",
    flex: 1.3,
    editable: true,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'left',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
  },

  {
    field: "reportDay",
    headerName: "REPORT",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    field: "cycleStartDate",
    headerName: "START",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },

  {
    field: "cycleEndDate",
    headerName: "END",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },

  {
    field: "cutOffDay",
    headerName: "CUT OFF",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },

  {
    field: "payoutDay",
    headerName: "PAYOUT BY",
    flex: 0.5,
    editable: true,
    type: "singleSelect",
    headerAlign: "center",
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params.value}
      </Box>
    ),
    valueOptions: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },

  {
    field: "expiryStartDate",
    headerName: "BEGIN",
    type: "date",
    flex: .7,
    headerAlign: "center",

    editable: true,
    renderCell: (params) => {
      // Format the date for display
      return (
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
       <span>
          {params.value ? format(new Date(params.value), "MM/dd/yyyy") : ""}
        </span>
      </Box>
      );
    },
    renderEditCell: (params) => {
      // Custom edit component
      return (
        <TextField
          type="date"
          value={
            params.value ? format(new Date(params.value), "yyyy-MM-dd") : ""
          }
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
        />
      );
    },
  },
  {
    field: "expiryEndDate",
    headerName: "EXPIRY",
    type: "date",
    flex: .7,
    headerAlign: "center",
    editable: true,
    renderCell: (params) => {
      // Format the date for display
      return (
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
       <span>
          {params.value ? format(new Date(params.value), "MM/dd/yyyy") : ""}
        </span>
      </Box>
      );
    },
    renderEditCell: (params) => {
      // Custom edit component
      return (
        <TextField
          type="date"
          value={
            params.value ? format(new Date(params.value), "yyyy-MM-dd") : ""
          }
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
        />
      );
    },
  },
];

// Add Dealer page - earmark
export const allAccountsEarmarkColumnHeader = (renderButton) => [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    headerAlign: "left",
    hide: true, // hide column header
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.7,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
    renderCell: (params) => (
      <div style={{ paddingLeft: "8px" }}>{params.value}</div>
    ),
  },
  {
    field: "date",
    flex: 0.6,
    headerName: "DATE",
    headerAlign: "left",
  },
  {
    field: "code",
    headerName: "CODE",
    flex: 0.6,
    headerAlign: "left",
  },

  {
    field: "reason",
    headerName: "REASON",
    flex: 1,
    headerAlign: "left",
  },

  {
    field: "addButton",
    headerName: "EARMARK",
    flex: 1,
    headerAlign: "left",
    filterable: false,
    renderCell: (params) =>
      params.value ? (
        renderButton(params.row)
      ) : (
        <CurrencyCellRenderer value={params.row.earmark} />
      ),
  },
];

// Add Dealer page - credit debit
export const allAccountsCreditDebitColumnHeader = (renderButton) => [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "accountName",
    headerName: "NAME",
    flex: 1.7,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
    renderCell: (params) => (
      <div style={{ paddingLeft: "8px" }}>{params.value}</div>
    ),
  },
  {
    field: "accountCode",
    flex: 0.6,
    headerName: "CODE",
    headerAlign: "left",
  },
  {
    field: "vendorCode",
    headerName: "ACTION",
    flex: 1,
    filterable: false,
    headerAlign: "left",
    renderCell: (params) => renderButton(params.row),
  },
];

export const debitCreditAccountDetailsColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "code",
    headerName: "CODE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "type",
    flex: 1,
    headerName: "TYPE",
    headerAlign: "left",
  },
  {
    field: "details",
    headerName: "DESCRIPTION",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "date",
    headerName: "DATE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "referenceNo",
    headerName: "REFERENCE NO.",
    flex: 1,
    hide: true,
    filterable: false,
    headerAlign: "left",
  },
  {
    field: "isEditable",
    headerName: "EDITABLE",
    flex: 0.5,
    hide: true,
    filterable: false,
    headerAlign: "left",
  },

  {
    field: "status",
    headerName: "STATUS",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    cellClassName: "name-column--cell",
  },
  {
    field: "amount",
    headerName: "AMOUNT",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];


export const onHoldSummaryColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "code",
    flex: 1,
    headerName: "CODE",
    headerAlign: "left",
  },
  {
    field: "startDate",
    headerName: "START DATE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "endDate",
    headerName: "END DATE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "vendor",
    headerName: "VENDOR",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "invoice",
    headerName: "INVOICE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "payout",
    headerName: "PAYOUT",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];


// Payout Dates incentive list header

export const payoutDatesIncentiveColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "cycleDate",
    flex: 1,
    headerName: "CYCLE DATE",
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "reportDay",
    headerName: "REPORT DAY",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "cutOffDay",
    headerName: "CUT OFF DAY",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "payoutDay",
    headerName: "PAYOUT DAY",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "expiry",
    headerName: "EXPIRY",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
];

// Witholding tax screen list header
export const withholdingTaxColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "status",
    flex: 1,
    headerName: "STATUS",
    headerAlign: "left",
    cellClassName: "name-column--cell",
  },
  {
    field: "code",
    headerName: "CODE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "vendor",
    headerName: "VENDOR",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "companyType",
    headerName: "COMPANY TYPE",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "payout",
    headerName: "PAYOUT",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];




// payout Details columns
export const exclusionTransactionTypeColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "exclusionTransactionTypes",
    flex: 1.2,
    headerName: "Exclusion Transaction Types",
    headerClassName: (params) =>
      params.field === "exclusionTransactionTypes" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },

  {
    field: "reportDate",
    headerName: "REPORT",
    flex: 0.5,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "reportDate" ? "bold-header-style" : null,
  },
  
  {
    field: "cutOffDate",
    headerName: "CUT OFF",
    headerClassName: (params) =>
      params.field === "cutOffDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "payOutDate",
    headerName: "PAYOUT BY",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "incentiveAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerClassName: (params) =>
      params.field === "incentiveAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];



// payout Details columns
export const dealerPayoutSummaryColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "companyName",
    flex: 1.2,
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "displayName" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },

  {
    field: "companyCode",
    headerName: "CODE",
    flex: 0.5,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "companyCode" ? "bold-header-style" : null,
  },
  
  {
    field: "vendor",
    headerName: "VENDOR",
    headerClassName: (params) =>
      params.field === "vendor" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
 
  {
    field: "summaryAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerClassName: (params) =>
      params.field === "summaryAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
];

// payout Details columns
export const payoutDetailsColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "displayName",
    flex: 1.2,
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "displayName" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    type: "string",
  },

  {
    field: "reportDate",
    headerName: "REPORT",
    flex: 0.5,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "reportDate" ? "bold-header-style" : null,
    
    type: "date",
    filterOperators: getGridDateOperators().filter(
      (operator) => operator.value === "is"
    ),
  },
  
  {
    field: "cutOffDate",
    headerName: "CUT OFF",
    headerClassName: (params) =>
      params.field === "cutOffDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",

    type: "date",
    filterOperators: getGridDateOperators().filter(
      (operator) => operator.value === "is"
    ),
  },
  {
    field: "payOutDate",
    headerName: "PAYOUT BY",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
    type: "date",
  },
  {
    field: "summaryAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerClassName: (params) =>
      params.field === "summaryAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
];

// payout summary details columns
export const payoutDealersColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "displayName",
    flex: 1.4,
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "displayName" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    type: "string",
  },
  {
    field: "companyCode",
    flex: 0.5,
    headerName: "CODE",
    headerClassName: (params) =>
      params.field === "companyCode" ? "bold-header-style" : null,
    headerAlign: "left",
    type: "string",
  },
  {
    field: "startDate",
    headerName: "START",
    flex: 0.5,
    headerAlign: "left",
    type: "date",
    filterOperators: getGridDateOperators().filter(
      (operator) => operator.value === "is"
    ),
  },
  {
    field: "endDate",
    headerName: "END",
    flex: 0.5,
    headerAlign: "left",
    type: "date",
    filterOperators: getGridDateOperators().filter(
      (operator) => operator.value === "is"
    ),
  },
  {
    field: "vendor",
    headerName: "VENDOR",
    flex: 1,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "vendor" ? "bold-header-style" : null,
    type: "string",
    },
  // {
  //   field: "invoice",
  //   headerName: "INVOICE",
  //   headerClassName: (params) =>
  //     params.field === "invoice" ? "bold-header-style" : null,
  //   flex: 1,
  //   hide: true,
  //   headerAlign: "left",
  // },
  {
    field: "summaryAmount",
    headerName: "PAYOUT",
    flex: 1,
    headerClassName: (params) =>
      params.field === "summaryAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
];

// payout all tranasction details
// {
//   "yesId": "01173815076@yes.my",
//   "transactionNo": "YSHP0193c1006837",
//   "type": "MNP - Prepaid Sim Reimbursement",
//   "transactionDate": "2023-06-22",
//   "planName": "YES FT5G Prepaid Plan",
//   "transactionAmount": 0,
//   "incentiveAmount": 1.9,
//   "companyCode": "A0060",
//   "startDate": "2023-07-01",
//   "endDate": "2023-07-31",
//   "payoutCycle": "Weekly : 22nd - 30th/31st",
//   "payoutStatus": "Hold",
//   "payoutDate": "2023-07-08",
//   "id": 111671
// },

// payout summary columns
export const payoutAllTransactionColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "yesId",
    flex: 1,
    headerName: "YES ID",
    headerClassName: (params) =>
      params.field === "yesId" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "transactionNo",
    headerName: "TRX NO.",
    flex: 0.9,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "transactionNo" ? "bold-header-style" : null,
  },
  {
    field: "transactionType",
    headerName: "TYPE",
    flex: 1.5,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "transactionType" ? "bold-header-style" : null,
  },
  {
    field: "transactionDate",
    headerName: "DATE",
    headerClassName: (params) =>
      params.field === "transactionDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "planName",
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "planName" ? "bold-header-style" : null,
    flex: 1,
    headerAlign: "left",
  },
  // {
  //   field: "transactionAmount",
  //   headerName: "AMOUNT",
  //   flex: 0.5,
  //   headerClassName: (params) =>
  //     params.field === "transactionAmount" ? "bold-header-style" : null,
  //   headerAlign: "left",
  //   cellClassName: "bold-column--cell",
  //   renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  // },
  {
    field: "incentiveAmount",
    headerName: "INCENTIVE",
    flex: 0.5,
    headerClassName: (params) =>
      params.field === "incentiveAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
  {
    field: "companyCode",
    headerName: "CODE",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "startDate",
    headerName: "START",
    flex: 1,
    hide: true,

    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "endDate",
    headerName: "END",
    flex: 1,
    hide: true,

    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "payoutCycle",
    headerName: "CYCLE",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "payoutStatus",
    headerName: "STATUS",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "payoutDate",
    headerName: "PAYOUT DATE",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
];

// {
//   "batchNo": 58,
//   "version": 2,
//   "type": "Device Reimbursement",
//   "transactionType": "MNP - Prepaid Sim Reimbursement",
//   "companyCode": "A7277",
//   "id": 111730,
//   "yesId": "01173839668@yes.my",
//   "transactionNo": "YSHP261e41113037",
//   "transactionDate": "06/07/2023",
//   "planName": "YES Prepaid FT5G Plan",
//   "transactionAmount": 0,
//   "incentiveAmount": 1.9
// },

export const onHoldAllTransactionColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "yesId",
    flex: .9,
    headerName: "YES ID",
    headerClassName: (params) =>
      params.field === "yesId" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "transactionNo",
    headerName: "TRX NO.",
    flex: 0.7,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "transactionNo" ? "bold-header-style" : null,
  },
  {
    field: "transactionType",
    headerName: "TYPE",
    flex: 1,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "transactionType" ? "bold-header-style" : null,
  },
  {
    field: "transactionDate",
    headerName: "DATE",
    headerClassName: (params) =>
      params.field === "transactionDate" ? "bold-header-style" : null,
    flex: 0.5,
    headerAlign: "left",
  },
  {
    field: "planName",
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "planName" ? "bold-header-style" : null,
    flex: 1,
    headerAlign: "left",
  },
  // {
  //   field: "transactionAmount",
  //   headerName: "AMOUNT",
  //   flex: 0.5,
  //   headerClassName: (params) =>
  //     params.field === "transactionAmount" ? "bold-header-style" : null,
  //   headerAlign: "left",
  //   hide: false,
  //   cellClassName: "bold-column--cell",
  //   renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  // },
  {
    field: "incentiveAmount",
    headerName: "INCENTIVE",
    flex: 0.5,
    headerClassName: (params) =>
      params.field === "incentiveAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
    sortable: false,
  },
  {
    field: "companyCode",
    headerName: "CODE",
    flex: 1,

    hide: true,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "startDate",
    headerName: "START",
    flex: 1,
    hide: true,

    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "endDate",
    headerName: "END",
    flex: 1,
    hide: true,

    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "payoutCycle",
    headerName: "CYCLE",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "payoutStatus",
    headerName: "STATUS",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "payoutDate",
    headerName: "PAYOUT DATE",
    flex: 1,
    hide: true,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "actions",
    headerName: "Actions",
    flex: 0.5,
    cellClassName: "bold-column--cell",
    renderCell: (params) => (
        <EditIcon
          style={{ cursor: "pointer" }}
        />
    ),
  },
];

// payout summary columns
export const payoutSummaryColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "payoutCycle",
    flex: 1,
    headerName: "CYCLE",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "payoutStatus",
    headerName: "STATUS",
    flex: 1,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    cellClassName: "name-column--cell",
  },
  {
    field: "cutOffDate",
    headerName: "CUT OFF",
    flex: 1,
    headerAlign: "left",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "payOutDate",
    headerName: "PAYOUT DATE",
    headerClassName: (params) =>
      params.field === "payOutDate" ? "bold-header-style" : null,
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "summaryAmount",
    headerName: "DETAILS",
    flex: 1,
    headerClassName: (params) =>
      params.field === "summaryAmount" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
    renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
  },
];


// {
//   "exclusionDetailsId": "15",
//   "clientName": "Ferkin satus",
//   "yesId": "1001",
//   "billingAccountNo": "01117313817@yes.my",
//   "reason": "testing u",
//   "exclusionStartDate": "2024-09-04",
//   "exclusionEndDate": "2024-06-04"
// }

// get exclusion columns
export const exclusionColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "exclusionDetailsId",
    filterable: false,
    headerName: "Exclusion Details Id",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "clientName",
    flex: 1,
    headerName: "NAME",
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "reason",
    headerName: "REASON",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "yesId",
    headerName: "YES ID",
    flex: 1,
    headerAlign: "left",
    cellClassName: "name-column--cell",
  },
  {
    field: "billingAccountNo",
    headerName: "BILLING ACCOUNT",
    flex: 1,
    headerAlign: "left",
  },
 
  {
    field: "exclusionStartDate",
    headerName: "EXCLUSION",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "exclusionEndDate",
    headerName: "UNTILL",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
];

export const sampleColumnHeader = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "left",
    cellClassName: "super-app-theme--cell",
  },
  {
    field: "registrarId",
    headerName: "REGISTER ID",
    flex: 1,
    headerAlign: "left",
    AlignVerticalCenter: true,
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1,
    cellClassName: "name-column--cell",
    headerAlign: "left",
  },
  {
    field: "age",
    flex: 0.5,
    headerName: "AGE",
    type: "number",
    headerAlign: "left",
    align: "left",
    headerAlign: "left",
  },
  {
    field: "phone",
    headerName: "PHONE NUMBER",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "email",
    headerName: "EMAIL",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "address",
    headerName: "ADDRESS",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "city",
    headerName: "CITY",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "zipCode",
    headerName: "ZIPCODE",
    flex: 1,
    headerAlign: "left",
  },
];

// cash out limits columns
export const cashOutLimitsColumnHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.1,
    hide: true,
    headerClassName: (params) =>
      params.field === "id" ? "bold-header-style" : null,
    headerAlign: "left",
  },
  {
    field: "accountName",
    flex: 1.5,
    headerName: "NAME",
    headerClassName: (params) =>
      params.field === "accountName" ? "bold-header-style" : null,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "accountCode",
    headerName: "CODE",
    flex: 0.5,
    headerAlign: "left",
    // cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "tier",
    headerName: "TIER",
    flex: 0.4,
    headerAlign: "left",
    // cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "daily",
    headerName: "DAILY",
    flex: 1,
    headerAlign: "left",
    // cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "weekly",
    headerName: "WEEKLY",
    flex: 1,
    headerAlign: "left",
    // cellClassName: "bold-text-color-with-grey-color",
  },
  {
    field: "monthly",
    headerName: "MONTHLY",
    flex: 1,
    headerAlign: "left",
    // cellClassName: "bold-text-color-with-grey-color",
  },
];

// cluster columns for role and access management
export const clusterColumnsHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 2.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "users",
    headerName: "USERS",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "roles",
    headerName: "ROLES",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "modules",
    headerName: "MODULES",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
];


// cluster roles
export const rolesHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 3,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
    field: "users",
    headerName: "USERS",
    flex: 0.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },
  {
      field: "settings",
      headerName: "SETTINGS",
      flex: 0.5,
      renderCell: (params) => (
        <MoreOptionsButton row={params.row.id} />
      ),
    },
  
];
const MoreOptionsButton = ({ row }) => {
    const companyCode = row.id;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleOptionClick = (option, event) => {
      event.stopPropagation();
      DebugLog(`Option ${option} clicked` + JSON.stringify(row));
      //getAttachmentDetails(row);
      handleClose();
    };

    return (
      <>
        <IconButton onClick={handleClick}>
          <Settings />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={(event) => event.stopPropagation()} // Prevent row click even inside the menu
        >
          <MenuItem onClick={(event) => handleOptionClick("Download", event)}>
            View Settings
          </MenuItem>
          {/* <MenuItem onClick={(event) => handleOptionClick("View", event)}>
            View Attachment
          </MenuItem> */}
        </Menu>
      </>
    );
  };

// cluster users
export const clusterUsersHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "cluster",
    headerName: "CLUSTER",
    flex: 3,
    headerAlign: "left",
  },
  {
    field: "role",
    headerName: "ROLE",
    flex: 0.5,  
    headerAlign: "left",
  },
  {
    field: "settings",
    headerName: "SETTINGS",
    flex: 0.5,
    headerAlign: "left",
     cellClassName: "bold-column--cell",
  }
  
];


// cluster Logs
export const clusterLogsHeader = [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 3,
    headerAlign: "left",
  },
  {
    field: "cluster",
    headerName: "CLUSTER",
    flex: 0.5,  
    headerAlign: "left",
  },
  {
    field: "role",
    headerName: "ROLE",
    flex: 0.5,  
    headerAlign: "left",
  },
  {
    field: "activity",
    headerName: "ACTIVITY",
    flex: 0.5,  
    headerAlign: "left",
  },

  ];

  